import { PURCHASE_ORDER_LINE_ITEMS_CRUD_ACTION_CREATORS } from '../actions/purchase_order_line_items_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';

const fetchUtils = new FetchUtils();

//export const purchaseRequestsRestCrudThunksForBuyer = new RestCrudThunks('purchase_requests', 'purchase_request', 'purchaseRequest', 'purchaseRequests', PURCHASE_REQUESTS_CRUD_ACTION_CREATORS, null, ROLE_TYPES.BUYER);
export const purchaseOrderLineItemsRestCrudThunksForSupplier = new RestCrudThunks(
	'purchase_order_line_items',
	'purchase_order_line_item',
	'purchaseOrderLineItem',
	'purchaseOrderLineItems',
	PURCHASE_ORDER_LINE_ITEMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

export const receiveLineItemQuantity = (lineItemId, quantity) => {
	const apiUrl = `/api/v1/supplier/inventory/purchase_order_line_items/receive_quantity/${lineItemId}/${quantity}`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.patch(getBackendUri() + apiUrl, {
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
			})
			.then(parseJSON)
			.then((d) => {
				if (d.status === 'error') {
					reject(d.message);
				} else {
					resolve(d.json.data);
				}
			})
			.catch((d) => {
				reject(d.message);
			});
	});
};
